import { Form, Formik } from "formik";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import * as Yup from 'yup';
import InputFormik from "../../../../common/components/form/InputFormik";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Nome da categoria obrigatório"),
})

type PropsFormCreateCategory = {
  onSubmit: (values: { name: string }) => void;
}

function FormCreateCategory(props: PropsFormCreateCategory) {
  const initialValues = { name: '' }

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    await props.onSubmit(values);
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, handleSubmit }) => {
        return (
          <Form>
            <InputFormik
              label='Nome da Categoria:'
              name='name'
              className='w-full'
              required={true}
            />
            <div className="flex justify-end">
              <ButtonWithLoader isLoading={isSubmitting} onClick={handleSubmit}> Enviar </ButtonWithLoader>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default FormCreateCategory;
